import React from "react";
import { Helmet } from "react-helmet";
import Container from "@material-ui/core/Container";
import makeStyles from "@material-ui/core/styles/makeStyles";
import { endOfTitle } from "../../../constants/constants";
import FilterResults from "../components/FilterResults";
import Filter from "../components/Filter";
import { BillingPageProvider } from "../BillingContext";
import { IBillingPageParams } from "../types";

const useStyles = makeStyles(() => ({
  root: {
    display: "flex",
    justifyContent: "space-between",
    columnGap: 24,
    width: 1147,
    padding: 0,
  },
  filterContainer: {
    position: "relative",
  },
  filterResultContainer: {
    width: "100%",
  },
}));

const BillingPage = ({
  showFilter,
  schoolId,
  agentId,
  parentId,
  studentId,
}: IBillingPageParams) => {
  const classes = useStyles();

  return (
    <>
      <Helmet>
        <title>Billing{endOfTitle}</title>
      </Helmet>
      <BillingPageProvider
        showFilter={showFilter}
        schoolId={schoolId}
        agentId={agentId}
        parentId={parentId}
        studentId={studentId}
      >
        <Container maxWidth="lg" className={classes.root}>
          {showFilter && (
            <div className={classes.filterContainer}>
              <Filter />
            </div>
          )}
          <div className={classes.filterResultContainer}>
            <FilterResults />
          </div>
        </Container>
      </BillingPageProvider>
    </>
  );
};

export default React.memo(BillingPage);
